import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,useNavigate } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import PrivateMenu from './../components/menus/PrivateMenu';
import PrivateSideMenu from './../components/menus/PrivateSideMenu';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../constants';
import $ from 'jquery';
const GlobalStyles = createGlobalStyle`
	
`;
const JPage= ({formId}) =>{
	const navigate=useNavigate();
	const [flag,setFlag]=useState(1);
	useEffect(()=>{
		/*const _s=localStorage.getItem("_lio");
		if(_s!=null  && _s.length!=0){
			$.post(API_CORE_SERVER+"/api/user/isValidToken.php","i="+_s,async function(result) {
				if(result.status===1){ 
					setFlag(1);
				} else navigate(URLPREFIX+"/login");
			});
		} else navigate(URLPREFIX+"/login");*/
	},[])
  return(
  <div className="wraper">
	  {flag==1?
	  	<>
			
				<GlobalStyles/>
				<PrivateMenu />
				<PrivateSideMenu formId={formId}/>
	  
		</>
		:
		<></>
	  }
		
  </div>	
	);
};
export default JPage;